var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "RBACMrktPlaceServicesModal", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content first-modal-content" }, [
          _c("div", { staticClass: "modal-header modal-bgcolor" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: { click: _vm.cancelPermissions },
              },
              [_vm._v(" × ")]
            ),
            _c("div", { staticClass: "modal-title" }, [
              _vm._v("Master Services"),
            ]),
            _c("hr"),
          ]),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm._m(0),
              _vm._l(_vm.servicesList, function (service, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass:
                      "col-md-10 col-sm-10 col-xs-11 bt-border ml-40",
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-8 col-xs-9 pd" }, [
                        _c(
                          "div",
                          { staticClass: "cust_label label-selected" },
                          [_vm._v(_vm._s(service.name))]
                        ),
                      ]),
                      _c("div", { staticClass: "col-sm-3 col-xs-2" }, [
                        _c(
                          "div",
                          {
                            staticClass: "edit-lnk",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.openPermissionsPopup(service)
                              },
                            },
                          },
                          [_vm._v(" edit ")]
                        ),
                      ]),
                    ]),
                  ]
                )
              }),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass:
                "col-sm-12 col-xs-12 col-md-12 footer remove_button_padding",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-3 col-md-offset-8 col-sm-offset-8 col-xs-offset-6 col-sm-3 col-xs-5 xs-pd-lt-0",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-white-button",
                      attrs: { type: "button" },
                      on: { click: _vm.cancelPermissions },
                    },
                    [_vm._v(" OK ")]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _c("rbac-mrktplace-modules-modal", {
        attrs: { selectService: _vm.selectedService },
        on: { updatePermissions: _vm.updatePermissions },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-10 col-sm-10 col-xs-11 bt-border ml-40" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-8 col-xs-9 pd" }, [
            _vm._v("Services access"),
          ]),
          _c("div", { staticClass: "col-sm-3 col-xs-2 txt-alg-rt" }, [
            _vm._v("Permissions"),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }